import { controlsContainerStyles } from "@insite/content-library/Widgets/ProductList/ProductListControlsContainer";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

Object.assign(controlsContainerStyles, {
    container: {
        gap: 0,
        css: css`
            width: 100%;
            justify-content: space-between;
        `,
    },
    countGridItem: {
        width: [12, 12, 6, 6, 6],
    },
    sortGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: ["left", null, "right", null, null], properties: ["text-align"] }],
                    mediaOptions.min,
                )}
        `,
    },
});
